import ReqClient from './request.class'

// 判断广告组是否有创意
export async function ksCreative(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/creative/hasCreative',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建广告组
export async function createCampaign(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/campaign/create/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 快手批量失败修改
export async function failedTasksModify(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateKuaiShouBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告组
export async function getCampaign(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/campaign/get/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新广告组
export async function uploadCampaign(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/campaign/update/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取计划详细信息
export async function queryByAdIdAndMediaId(params) {
  const Req = new ReqClient({
    url: '/api/caohua/plan/queryByAdIdAndMediaId',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建计划
export async function createPlan(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/ad/create',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新计划
export async function updatePlan(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/ad/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号可用人群包
export async function getPopulationList(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getPopulationList',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号可用的应用定向
export async function getAppSearch(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getAppTargetingList',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号应用列表
export async function getAppList(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getAppList',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取行为兴趣类目词
export async function getBehaviorAndInterest(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getBehaviorAndInterest',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取行为兴趣关键词
export async function queryKeyword(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/queryKeyword',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取定向标签
export async function getTargetingTags(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getTargetingTagList',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意信息
export async function getCreative(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/creative/get',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建创意
export async function createCreative(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/creative/create',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新创意
export async function uploadCreative(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/creative/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 本地上传创意图片/视频
export async function uploadMeterialCreative(params) {
  const Req = new ReqClient({
    url: '/api/caohua/imageInfo/upload',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取动态词包
export async function getCreativeWords(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getCreativeWord',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意分类
export async function getCreativeCategory(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getCreativeCategory',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意封面贴纸
export async function getCreativeStyles(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getCreativesStyles',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取快手视频推荐封面
export async function getCreativeKeyframe(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getCreativeWord',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取快手安卓应用下载落地页
export async function getLandpageData(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getLpPage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号下所有的落地页
export async function getAllPagesByAccount(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getOrderPage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取快手高级创意
export async function getAdvCardData(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getAdvCard',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取试玩按钮列表
export async function getPlayButtons(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/playable/play_buttons',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取试玩列表
export async function getPlayLists(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/playable/play_lists',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 快手-获取磁力落度页数据
export async function getMagneticPage(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getMagneticPage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 快手获取原生视频 /api/kuaishou/tools/getNativePhoto
export async function getNativePhoto(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/getNativePhoto',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
